export function getSelectionSubtitleVariantStyles(type, displayBoostInelligibleLabel, finalScore, marketBlurb) {
    return {
        $extendFromVariant: `${type}SelectionCardSubtitle`,
        root: {
            marginBottom: displayBoostInelligibleLabel || finalScore || marketBlurb ? "$s1" : "$s2",
        }
    };
}
//# sourceMappingURL=getSelectionSubtitleVariantStyles.js.map